import { transport } from 'config/transport';

export function callApiGetDuChiCaNhan(congDoanId, nunId, academicYear) {
    return transport.get(`/congdoan/${congDoanId}/nun/duchi/${nunId}`, { params: { academicYear } });
}
